<template>
	<el-row class="ref-tree-add-panel">
		<el-col :span="12" style="padding-right: 10px;">
			<ref-tree-panel ref="tree"
				:model="model"
				:defTreeData="defTreeData"
				:mulSelect="mulSelect"
				:checkStrictly="checkStrictly"
                :filterMethod="filterMethod"
				v-model="currentValue"
			></ref-tree-panel>
			</el-col>
        <el-col :span="12">
            <el-table class="ref-table"
                      :data="tableData"
                      :height="447"
                      style="width: 100%">
                <el-table-column
                        prop="dishName"
                        label="已选数据"
                >
                    <template slot-scope="scope">
                        <span :style="{ float: 'left', 'margin-left': (!!scope.row._groupName?20:0) + 'px' }">{{ scope.row[model.getRefFields().name] }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label=""
                        width="90">
                    <template slot-scope="scope">
                        <el-button v-if="!!scope.row._groupName"
                                type="text" @click="removeData(scope.row)"
                                size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
	</el-row>
</template>
<script>
	import RefTreePanel from './refTreePanel.vue';
	export default{
		props:{
            model:Object,
            filterMethod:Function,  //用来对展示结果集进行过滤
            defTreeData:Array,
            mulSelect:{
                type:Boolean,
                default:false
            },
            checkStrictly:{
                type:Boolean,
                default:false
            },
            value:[Object,Array],
		},
		data(){
			return{
				currentValue:this.value,
				tableData:[],
			}
		},
		watch:{
			currentValue:{
                immediate: true,
                handler:function(v, oldv){
                    
                    var filterResult =v?v.filter( d => this.model.filterResult(d)):[];
                	this.tableData = this.trunsferToTable(filterResult);
                    this.$emit('input',filterResult);
                }
			},
            defTreeData:{
                immediate: true,
                handler:function(v, oldv){
                    
                    if(v && v.length){
                        this.tableData = this.trunsferToTableByIds(this.currentValue)
                    }else{
                        this.tableData = [];
                    }
                }
            },

            filterMethod:{
                immediate: true,
                handler:function(v, oldv){

                }
            },
		},
        components: {
            RefTreePanel,
        },
        methods:{
            //将左边树选择数据生成右边列表，支持带分组
        	trunsferToTable:function(datas){
                
        		if(!datas || !datas.length) return [];
        		var refFields = this.model.getRefFields();
        		// var filterResult = datas.filter( d => this.model.filterResult(d));
        		var groupName = this.model.getMulGroupField() || "_groupName";
        		var groups = {};
        		datas.forEach(d =>{
        			if (!groups[d[groupName]]){
        				var g = {};
        				g[refFields.name] = d[groupName];
        				groups[d[groupName]] = [g];
        			}
        			groups[d[groupName]].push(d);
        		});
        		var concatdatas = [];
                for(var okey in groups){
                    if(groups[okey] && groups[okey].length>1)
                        concatdatas = concatdatas.concat(groups[okey]);
                }
                return concatdatas;
        	},
            //根据ID查找树节点数据，然后加载到右表
            trunsferToTableByIds:function(ids){
                
                var listDatas = [];
                if(!ids || !ids.length){
                    return [];
                }
                return this.trunsferToTable(ids.map(id=>{
                    if(id.id) return id;  //如果对象有id属性，说明外部传递的是对象，否则为主键
                    if(listDatas.length==0) listDatas = this.getAllChildren(this.defTreeData);
                    return listDatas.find(d=>d.id==id);
                }).filter(d=>!!d));
            },
            getAllChildren(nodes){
                var allNodes = [];
                nodes.forEach(node=>{
                    allNodes.push(node);
                    if(node.children && node.children.length) allNodes.push.apply(allNodes, this.getAllChildren(node.children));
                });
                return allNodes;
            },
        	removeData:function(row){
              
                var selectdata = this.currentValue;
        		var datas = selectdata.filter(d => d != row);
        		this.currentValue = datas;
        	}
        }
	}
</script>
<style>
	.ref-tree-add-panel .ref-table{
		height: 447px;

	}

</style>



// WEBPACK FOOTER //
// src/pub/components/baseRef/view/refTreeAddPanel.vue